module.exports = __webpack_public_path__ + "img/article4-5.8f81a0bd.png";